import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, Button } from '@shared/ui';
import { articleErrorKey } from '../model/presentation';

export function ArticleError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <Alert variant="destructive">
      <AlertTitle>{t(articleErrorKey(error))}</AlertTitle>
      {onRetry ? (
        <Button variant="outline" onClick={onRetry}>
          {t('auth.retry')}
        </Button>
      ) : null}
    </Alert>
  );
}
